'use client';

import { useEffect } from 'react';

import { flushPendingFavoriteRemovals } from '../../lib/flushPendingFavoriteRemovals';
import { isFullPageReload } from '../../lib/pendingRemoval';

export const FavoritesReloadFlush = () => {
  useEffect(() => {
    if (!isFullPageReload()) {
      return;
    }

    void flushPendingFavoriteRemovals();
  }, []);

  return null;
};
